import type {ReactElement} from 'react';
import React from 'react';
import type { TabToggleData} from '@Components/tabs-toggle/tabs-toggle.types';
import {TabsToggleSize, TabToggleVariant} from '@Components/tabs-toggle/tabs-toggle.types';
import {TabSquare} from '@Components/tabs-toggle/components/tab-square';
import styles from './tabs-toggle.module.scss';

export interface TabsToggleProps {
  className?: string;
  size?: TabsToggleSize;
  variant?: TabToggleVariant;
  data: Array<TabToggleData>;
  selectedId: string;
  onClick(id: string): void;
}

export function TabsToggle({className = '', size = TabsToggleSize.MEDIUM, variant = TabToggleVariant.DEFAULT, ...props}: TabsToggleProps): ReactElement | null {
  const onClickHandler = (id: string): void => {
    props.onClick(id);
  };

  const getTabs = (): Array<ReactElement> => {
    return props.data.map((item) => {
      return (
        <TabSquare
          key={item.id}
          size={size}
          variant={variant}
          isSelected={item.id === props.selectedId}
          data={item}
          onClick={(): void => {
            onClickHandler(item.id);
          }}
        />
      );
    });
  };

  return <div className={`${className} ${styles.container} flex-h-row radius-8 spacing-p-1 border-s-dark`}>{getTabs()}</div>;
}
